import { useEffect, useState } from "react";
import { ThematicTransport } from "src/app/transports/thematic";
import { ThematicListOptions } from "src/app/types/Thematic";

const useThematicsOptions = (initialRequest = true) => {
    const [thematicsOptions, setThematicsOptions] = useState<Array<ThematicListOptions>>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = () => {
        setLoading(true);
        ThematicTransport.allOptions({ isActive: 1 })
            .then((res) => {
                setThematicsOptions(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (initialRequest) fetch();
    }, []);

    return { thematicsOptions, refresh, error, loading };
};

export default useThematicsOptions;
